<template>
  <div class="table-pagination">
    <span class="table-pagination-item" v-bind:key="i" v-for="i in numberOfPages">
      <md-button
        v-if="showButton(i)"
        v-bind:disabled="parseInt(offset) === (i-1)*limit"
        @click="handleSwitchPage(limit, (i-1)*limit)">
          {{(i-1)*limit}} - {{i*limit}}
      </md-button>
      <span class="table-pagination-dotted" v-if="showDotted(i)">.</span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'TablePagination',
  props: {
    count: Number,
    limit: Number,
    offset: Number
  },
  computed: {
    numberOfPages () {
      return Math.floor(this.count / this.limit)
    }
  },
  created () {
    const { limit, offset } = this
    this.$emit('created', { limit, offset })
  },
  methods: {
    handleSwitchPage (limit, offset) {
      this.$emit('switch-page', { limit, offset })
    },
    showButton (idx) {
      const { limit, offset, numberOfPages } = this
      return idx === 1 || (parseInt(offset) > (idx - 1) * limit - (3 * limit) && parseInt(offset) < (idx - 1) * limit + (3 * limit)) || idx === numberOfPages
    },
    showDotted (idx) {
      const { limit, offset, numberOfPages } = this
      return (
        idx !== 1 &&
        ((parseInt(offset) <= (idx - 1) * limit - (3 * limit) && parseInt(offset) > (idx - 1) * limit - (6 * limit)) ||
        (parseInt(offset) >= (idx - 1) * limit + (3 * limit) && parseInt(offset) < (idx - 1) * limit + (6 * limit))) &&
        idx !== numberOfPages
      )
    }
  }
}

</script>

<style scoped>
.table-pagination button {
  min-width: 20px !important;
  background-color: #eee;
}
.table-pagination-dotted {
  font-size: 50px;
}
</style>
